// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Carousel';



// WEBPACK FOOTER //
// ./components/Carousel/index.js